export default function truncateString(string: string, maxLength: number) {
  string = string.trim();

  const firstNewline = string.indexOf('\n');
  if (firstNewline !== -1) {
    if (firstNewline < maxLength) {
      return string.substring(0, firstNewline) + '...';
    }
  }

  const willTruncate = maxLength < string.length;
  if (!willTruncate) {
    return string;
  }

  // Use Array.from to properly handle Unicode characters
  const characters = Array.from(string);
  if (characters.length <= maxLength) {
    return string;
  }

  const truncatedCharacters = characters.slice(0, maxLength);
  const truncatedString = truncatedCharacters.join('');

  const lastSymbol = Math.max(
    truncatedString.lastIndexOf(' '),
    truncatedString.lastIndexOf('!'),
    truncatedString.lastIndexOf(')'),
    truncatedString.lastIndexOf("'"),
    truncatedString.lastIndexOf('"'),
    truncatedString.lastIndexOf('}'),
    truncatedString.lastIndexOf(']'),
    truncatedString.lastIndexOf(','),
    truncatedString.lastIndexOf('.'),
    truncatedString.lastIndexOf('-'),
  );

  if (lastSymbol === -1 || lastSymbol + 20 < truncatedString.length) {
    return truncatedString + '...';
  }

  return truncatedString.substring(0, lastSymbol) + '…';
}
